<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container>
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <!--label="合同编号"-->
            <a-form-item  :label="$t('label.contractNo')"  :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select :placeholder="$t('label.pleaseSelectTheContractNumber')" showSearch option-filter-prop="children"  option-label-prop="label" :disabled="conCodeDisable"  @change="conCodeChanged" v-decorator="['conCode',validatorRules.conCode]">
                <a-select-option
                  v-for="item in conCodeList"
                  :key="item.code"
                  :label="item.code"
                  :value="item.code">
                  {{ item.code + '|' + item.name}}
                </a-select-option>
              </a-select>
              <!--<j-dict-select-tag
                type="list"
                @change="conCodeChanged"
                v-decorator="['conCode', validatorRules.conCode]"
                :trigger-change="true"
                dictCode="efs_md_contract,code,id,breed_batch_code is null"
                placeholder="请选择合同编号"/>-->
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="批次编号"-->
            <a-form-item :label="$t('label.batchNumber')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input :disabled="codeDisable" v-decorator="['code', validatorRules.code]" :placeholder="$t('label.pleaseEnterTheBatchNumber')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="批次名称"-->
            <a-form-item :label="$t('label.batchName')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- <a-input  v-decorator="['name', validatorRules.name]" placeholder="请输入批次名称"></a-input> -->
            <mtc-lang-popover :whetherLang="whetherLang('name')" :popLists="getMainTablePop('name')">
                <a-input
                  v-decorator="['name']"
                  :read-only="whetherLang('name')"
                  @click="isLangClick('name', false)"
                  :placeholder="$t('label.pleaseEnterTheBatchName')"
                ></a-input>
              </mtc-lang-popover>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="饲养周期"-->
            <a-form-item :label="$t('label.feedingCycle')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['batchCycle']" :placeholder="$t('label.pleaseEnterTheFeedingCycle')" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="饲养天数"-->
            <a-form-item :label="$t('label.age')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['feedingStage']" :placeholder="$t('label.pleaseEnterAge')" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="12" >
            <!--label="公司"-->
            <a-form-item :label="$t('label.company')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select :placeholder="$t('label.pleaseSelectCompany')" v-decorator="['companyCode',validatorRules.companyCode]">
                <a-select-option
                  v-for="item in companyCodeList"
                  :key="item.orgCode"
                  :value="item.orgCode">
                  {{ item.departName }}
                </a-select-option>
              </a-select>
              <!--<j-dict-select-tag type="list" v-decorator="['companyCode', validatorRules.companyCode]" :trigger-change="true" dictCode="sys_depart,depart_name,org_code,org_category='2' and del_flag='0'" :placeholder="$t('label.pleaseSelectCompany')"/>-->
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="养殖场"-->
            <a-form-item :label="$t('label.farms')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select :placeholder="$t('label.pleaseSelectFarms')" v-decorator="['farmCode',validatorRules.farmCode]">
                <a-select-option
                  v-for="item in farmCodeList"
                  :key="item.orgCode"
                  :value="item.orgCode">
                  {{ item.departName }}
                </a-select-option>
              </a-select>
             <!-- <j-dict-select-tag type="list" v-decorator="['farmCode', validatorRules.farmCode]" :trigger-change="true" dictCode="sys_depart,depart_name,org_code,org_category='5' and del_flag='0'" :placeholder="$t('label.pleaseSelectFarms')"/>-->
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="养户"-->
            <a-form-item :label="$t('label.grower')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select :placeholder="$t('label.pleaseSelectGrower')" v-decorator="['farmerCode',validatorRules.farmerCode]">
                <a-select-option
                  v-for="item in farmerCodeList"
                  :key="item.code"
                  :value="item.code">
                  {{ item.name }}
                </a-select-option>
              </a-select>
              <!--<j-dict-select-tag type="list" v-decorator="['farmerCode', validatorRules.farmerCode]" :trigger-change="true" dictCode="efs_md_farmer,name,code" placeholder="请选择养户编号"/>-->
            </a-form-item>
          </a-col>
<!--          <a-col :span="12">-->
<!--            <a-form-item label="畜禽类别" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
<!--              <j-dict-select-tag disabled type="list" v-decorator="['breedSpeciesCode']" :trigger-change="true" dictCode="cqlb" placeholder="请选择畜禽类别"/>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
          <a-col :span="12">
            <!--label="品类"-->
            <a-form-item  :label="$t('label.species')"  :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag disabled type="list" v-decorator="['breedClassCode']" :trigger-change="true" dictCode="sys_category,name,code,pid=(select id from sys_category where code='A01' AND name = '物种分类')" :placeholder="$t('label.pleaseSelectStrain')"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--:label="$t('label.strain')"-->
            <a-form-item :label="$t('label.strain')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag disabled type="list" v-decorator="['breedVarietyCode']" :trigger-change="true" :dictCode="dictBreedVarietyCode" :placeholder="$t('label.pleaseSelectAStrain')"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="代次"-->
            <a-form-item :label="$t('label.generation')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag disabled
                type="list"
                v-decorator="['batchType']"
                :trigger-change="true"
                dictCode="batch_type"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="初始日龄"-->
            <a-form-item :label="$t('label.initialAge')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number  v-decorator="['housingDays',{'initialValue': '1'},validatorRules.housingDays]" :placeholder="$t('label.pleaseEnterTheInitialAge')" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="计划入雏数量"-->
            <a-form-item :label="$t('label.plannedNumberOfChicks')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number  v-decorator="['planHousingAmount', validatorRules.planHousingAmount]" :placeholder="$t('label.pleaseEnterThePlannedNumberOfChicks')" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="实际入雏数量"-->
            <a-form-item :label="$t('label.actualNumberOfChicks')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['actHousingAmount']" :placeholder="$t('label.pleaseEnterTheActualNumberOfChicks')" style="width: 100%"/>
            </a-form-item>
          </a-col>
<!--          <a-col :span="12">-->
<!--            <a-form-item label="成本对象" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
<!--              <j-dict-select-tag disabled type="list" v-decorator="['costCenter']" :trigger-change="true" dictCode="efs_stocking_cost_item,name,code" placeholder="请选择成本对象"/>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
          <!--<a-col :span="12">
            <a-form-item label="是否有效" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['validFlag',{'initialValue': 'Y'}]" :trigger-change="true" dictCode="sfyx" placeholder="请选择是否有效"/>
            </a-form-item>
          </a-col>-->
          <a-col :span="12">
            <!--label="备注"-->
            <a-form-item :label="$t('label.remarks')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- <a-textarea v-decorator="['notes']" rows="4" placeholder="请输入备注"></a-textarea> -->
            <mtc-lang-popover :whetherLang="whetherLang('notes')" :popLists="getMainTablePop('notes')">
                <a-textarea
                  v-decorator="['notes']"
                  :read-only="whetherLang('notes')"
                  @click="isLangClick('notes', false)"
                  :placeholder="$t('label.pleaseEnterAComment')"
                ></a-textarea>
              </mtc-lang-popover>
            </a-form-item>
          </a-col>

          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">{{$t('button.submit')}}</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
    <mtc-lang-modal/>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import {getContractData} from '@/api/api'
  import { mtcLangModalMixin } from '@/mixins/mtcLangModalMixin'


  export default {
    name: 'EfsMdBreedBatchForm',
    mixins: [mtcLangModalMixin],
    components: {
      JFormContainer,
      JDictSelectTag,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        mainTable: 'efs_md_breed_batch',
        conCodeDisable:false,
        codeDisable:false,
        // form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        farmCodeList:[],//养殖场
        farmerCodeList:[],//养户
        companyCodeList:[],//公司
        conCodeList:[],//合同
        validatorRules: {
          conCode: {
            rules: [
              { required: true, message: this.$t('label.pleaseSelectTheContractNumber')},
            ]
          },
            code: {rules: [
                    {required: true, message: this.$t('label.pleaseEnterTheBatchNo')},
                    { validator: (rule, value, callback) => validateDuplicateValue('efs_md_breed_batch', 'code', value, this.model.id, callback)},
                ]},
          name: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterTheFlockName')},
            ]
          },
          companyCode:{
            rules: [
              { required: true, message: this.$t('label.pleaseSelectACompany')},
            ]
          },
          farmCode: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterFarmNo')},
            ]
          },
          farmerCode: {
            rules: [
              { required: true, message: this.$t('label.pleaseSelectGrower')},
            ]
          },
          housingDays: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterTheInitialAge')},
            ]
          },
          planHousingAmount: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterThePlannedNumberOfChicks')},
            ]
          },
        },
        url: {
          add: "/batchManage/efsMdBreedBatch/add",
          edit: "/batchManage/efsMdBreedBatch/edit",
          queryById: "/batchManage/efsMdBreedBatch/queryById",
          queryByConCode: '/newContractManage/efsMdContract/queryByCode'
        },
          dictBreedVarietyCode: "",
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
          getContractData({contractCode: ""}).then((res) => {
              if (res.success) {
                  this.conCodeList = res.result.efsMdContracts;
              }
          });
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'code','name','companyCode','batchCycle','feedingStage','farmCode','breedClassCode','breedVarietyCode','housingDays','planHousingAmount','actHousingAmount','notes','validFlag','conCode','farmerCode','batchType'))
        });
          this.initBreedClass(this.model.breedClassCode);
          if(this.model.id){
              this.conCodeDisable=true;
              this.codeDisable=true;
              getContractData({contractCode: this.model.conCode}).then((res) => {
                  if (res.success) {
                      this.farmCodeList = res.result.sysDepart;
                      this.farmerCodeList=res.result.efsMdFarmers;
                      this.companyCodeList=res.result.sysDeparts;
                  }
              });
          }else{
              this.conCodeDisable=false;
              this.codeDisable=false;
              this.model.farmCode = "";
              this.model.farmerCode="";
              this.model.companyCode="";
          }
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'code','name','companyCode','batchCycle','feedingStage','farmCode','breedClassCode','breedVarietyCode','housingDays','planHousingAmount','actHousingAmount','notes','validFlag','conCode','farmerCode','batchType'))
      },
      conCodeChanged(param) {
        this.model.planHousingAmount="";
        getAction(this.url.queryByConCode, { code: param }).then(res => {
          if (res.success) {
            this.form.resetFields()
            this.form.setFieldsValue({
              conCode: res.result.conCode,
              breedClassCode: res.result.breedClassCode,
              breedVarietyCode: res.result.breedStrainCode,
              batchCycle: res.result.breedCycleWeeks,
              feedingStage: res.result.breedCycleDays,
              planHousingAmount:res.result.planBreedQty,
              batchType:res.result.buffer1,
            })
          } else {
            this.$message.warning(res.message)
          }
            this.dictBreedVarietyCode = "sys_category,name,code,pid=(select id from sys_category where code= '" + res.result.breedClassCode + "')"
        });
          getContractData({contractCode: param}).then((res) => {
              if (res.success) {
                  this.farmCodeList = res.result.sysDepart;
                  this.farmerCodeList=res.result.efsMdFarmers;
                  this.companyCodeList=res.result.sysDeparts;
              }
          });
      },
        initBreedClass(value){
            if(value){
                this.dictBreedVarietyCode = "sys_category,name,code,pid=(select id from sys_category where code= '" + value + "')";
            }else {
                this.dictBreedVarietyCode = "";
            }
        },
    }
  }
</script>